import { rouletteApiGet } from './roulette-api';
import { mapHistoryItem } from './roulette.mappers';
import type { ApiFetchRoulettePrizeHistoryPort } from '~/handlers/ports/api-fetch-roulette-prize-history.port';
import type { PrizeHistoryPage } from '~/types/roulette';

export class ApostatudoApiFetchRoulettePrizeHistoryAdapter
  implements ApiFetchRoulettePrizeHistoryPort
{
  async handle(page: number): Promise<PrizeHistoryPage> {
    const json = await rouletteApiGet(`/roulettes/prizes?page=${page}`);

    const meta = json.meta ?? {};

    return {
      items: (json.data ?? []).map(mapHistoryItem),
      currentPage: meta.current_page ?? page,
      lastPage: meta.last_page ?? page,
    };
  }
}
